import { moveToFulfilled, remove } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import { FeedLoadFulfilledAction, FeedLoadOlderThreadsFulfilledAction } from '../../domains/feedLoad/actions.types';
import { SuggestedUsersDismissFulfilledAction } from '../../domains/suggestedUserDismiss/actions.types';
import { SuggestedUsersLoadAction, SuggestedUsersLoadMoreAction } from '../../domains/suggestedUsers/actions.types';

import { SuggestedUsers } from './types';
export const initialState: SuggestedUsers = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

export type SuggestedUsersAction =
  | SuggestedUsersLoadAction
  | SuggestedUsersLoadMoreAction
  | SuggestedUsersDismissFulfilledAction
  | FeedLoadFulfilledAction
  | FeedLoadOlderThreadsFulfilledAction;

const reducer: Reducer<SuggestedUsers, SuggestedUsersAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FEED.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.suggestedUsers);
    case 'FEED.LOAD_OLDER_THREADS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.suggestedUsers);
    case 'SUGGESTED_USERS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.suggestedUsers);
    case 'SUGGESTED_USERS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.suggestedUsers);
    case 'SUGGESTED_USERS.DISMISS_FULFILLED':
      return remove(state, [action.payload.userId]);
    default:
      return state;
  }
};

export default reducer;
